const questionnaire = () => import('@/page/qusetionnaire')
export default [{
  path: '/questionnairepaper',
  name: 'questionnairepaper',
  component: questionnaire,
  childred: []
}]


// WEBPACK FOOTER //
// ./src/router/qusetionnaire/index.js